export type AuditDebugMeta = {
    id: string;               // unique id for this attempt
    url: string;              // requested URL
    method: string;           // POST
    startedAt: number;        // Date.now()
    endedAt?: number;
    stage: "clicked" | "request_started" | "response_received" | "request_failed" | "json_invalid";
    status?: number;
    ok?: boolean;
    error?: string;
    requestBytes?: number;
    responseBytes?: number;
    durationMs?: number;
    responseSummary?: {
        snapshot_status?: string;
        regime?: string | null;
        iht_status?: string;
        missing?: string[]; // list of blocker codes
        decisions?: Record<string, any>;
    };
};


export type BackendFingerprint = {
    pid: string | null;
    startedAt: string | null;
    uptimeMs: string | null;
    gitSha: string | null;
    runId: string | null;
    capturedAt: number;
};

const KEY = "probate_last_audit_meta_v1";
const FP_KEY = "probate_last_backend_fp_v1";

export function setLastBackendFingerprint(fp: BackendFingerprint) {
    try {
        (window as any).__PROBATE_LAST_BACKEND_FP__ = fp;
        sessionStorage.setItem(FP_KEY, JSON.stringify(fp));
    } catch (e) {
        console.error("Failed to save backend fp", e);
    }
}

export function getLastBackendFingerprint(): BackendFingerprint | null {
    try {
        const w = (window as any).__PROBATE_LAST_BACKEND_FP__;
        if (w) return w as BackendFingerprint;
        const raw = sessionStorage.getItem(FP_KEY);
        return raw ? (JSON.parse(raw) as BackendFingerprint) : null;
    } catch {
        return null;
    }
}

export function setLastAuditMeta(meta: AuditDebugMeta) {
    try {
        (window as any).__PROBATE_LAST_AUDIT_META__ = meta;
        localStorage.setItem(KEY, JSON.stringify(meta));
    } catch (e) {
        console.error("Failed to save audit meta", e);
    }
}

export function getLastAuditMeta(): AuditDebugMeta | null {
    try {
        const w = (window as any).__PROBATE_LAST_AUDIT_META__;
        if (w) return w as AuditDebugMeta;
        const raw = localStorage.getItem(KEY);
        return raw ? (JSON.parse(raw) as AuditDebugMeta) : null;
    } catch {
        return null;
    }
}

export function newAuditId() {
    return `${Date.now()}_${Math.random().toString(16).slice(2)}`;
}
